import { forwardRef } from "react";
import { Ticket } from "lucide-react";
import { prizeEmoji } from "@/lib/api";

// Token / ticket style prize card. forwardRef so it can be captured to an image.
export const PrizeTicket = forwardRef(({ offer }, ref) => {
  const expires = offer.expiresAt ? new Date(offer.expiresAt) : null;
  return (
    <div ref={ref} data-testid="prize-ticket" className="relative bg-amber-400 rounded-3xl p-6 text-slate-950 overflow-hidden">
      <div className="absolute -left-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-slate-950" />
      <div className="absolute -right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-slate-950" />

      <div className="flex items-center gap-2 mb-1">
        <Ticket size={18} strokeWidth={2.5} />
        <span className="text-[11px] font-black uppercase tracking-[0.2em]">AppyOur · Prize Ticket</span>
      </div>

      <div className="text-5xl my-3">{prizeEmoji(offer.kind)}</div>
      <p className="font-display font-black text-2xl leading-tight">{offer.title}</p>
      <p className="text-sm font-bold mt-1 opacity-80">Won at {offer.venue}</p>

      <div className="border-t-2 border-dashed border-slate-950/30 mt-5 pt-4 flex items-end justify-between">
        <div>
          <p className="text-[10px] font-black uppercase tracking-wider opacity-70">Redeem code</p>
          <p className="font-display font-black text-2xl tracking-widest">{offer.code}</p>
        </div>
        <div className="text-right">
          <p className="text-[10px] font-black uppercase tracking-wider opacity-70">Valid until</p>
          <p className="font-bold text-sm">{expires ? expires.toLocaleString([], { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "short" }) : "—"}</p>
        </div>
      </div>
    </div>
  );
});

PrizeTicket.displayName = "PrizeTicket";
